import api from '~/services/api';
import PropTypes from 'prop-types';
import errorHandler from '~/Utils/errorHandler';
import { message } from 'antd';
import i18next from 'i18next';

const endPoint = 'estimateSubVendors';

// PAGINATION
export const paginationEstimateSubVendors = async params => {
  try {
    const { data } = await api.post(`/${endPoint}/pagination`, params);
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// FIND ALL
export const findAllEstimateSubVendors = async (filters) => {
  try {
    const { data } = await api.post(`/${endPoint}/findAll`, filters);
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// CREATE
export const createEstimateSubVendor = async values => {
  try {
    const { data } = await api.post(`/${endPoint}/create`, values);
    // message.success(i18next.t(`messages:${endPoint}.success`));
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// UPDATE
export const updateEstimateSubVendor = async values => {
  try {
    const { data } = await api.put(`/${endPoint}/update`, values);
    message.success(i18next.t(`messages:${endPoint}.successEdit`));
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// DELETE
export const deleteEstimateSubVendor = async id => {
  try {
    const { data } = await api.delete(`/${endPoint}/delete/${id}`);
    message.success(i18next.t(`messages:${endPoint}.successDeleted`));
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

paginationEstimateSubVendors.propTypes = {
  params: PropTypes.object.isRequired,
};

findAllEstimateSubVendors.propTypes = {
  filters: PropTypes.object.isRequired,
};

createEstimateSubVendor.propTypes = {
  values: PropTypes.object.isRequired,
};

updateEstimateSubVendor.propTypes = {
  values: PropTypes.object.isRequired,
};

deleteEstimateSubVendor.propTypes = {
  id: PropTypes.string.isRequired,
};
